module.exports = __webpack_public_path__ + "media/header-en.8097cb3f.mp4";